const tooltip = {
  mounted(el, binding) {
    const hide = binding.value?.hide;
    const tooltipText = typeof binding.value === "string" ? binding.value : binding.value.value;
    if (hide || !tooltipText) {
      return;
    }
    let position = ["top", "bottom", "left", "right"].find((pos) => binding.modifiers[pos]) || "top";
    const event = ["hover", "click", "focus"].find((e) => binding.modifiers[e]) || "hover";
    if (binding.value !== "string" && binding.value?.position) {
      position = binding.value.position;
    }
    const {
      showDelay = 100,
      hideDelay = 100,
      hideOnHover = true,
    } = typeof binding.value === "object" ? binding.value : {};
    let showTimeout = null;
    let hideTimeout = null;

    // creating tooltip
    el.style.position = "relative";
    const tooltip = document.createElement("div");
    const positionClasses = {
      top: "tooltip tooltip--top",
      bottom: "tooltip tooltip--bottom",
      left: "tooltip tooltip--left",
      right: "tooltip tooltip--right",
    };
    tooltip.className = positionClasses[position];
    tooltip.innerText = tooltipText;
    if (hideOnHover) {
      tooltip.classList.add("tooltip--no-events");
    }
    el.appendChild(tooltip);

    const showTooltip = () => {
      showTimeout = setTimeout(() => {
        tooltip.classList.add("tooltip--visible");
      }, showDelay);
    };

    const hideTooltip = () => {
      hideTimeout = setTimeout(() => {
        tooltip.classList.remove("tooltip--visible");
      }, hideDelay);
    };

    // Слушатель на document в click-режиме раньше не снимался → утечка. Собираем
    // все cleanup-операции в одну функцию и храним её на el для unmounted-хука.
    let docClickHandler = null;

    if (event === "hover") {
      el.addEventListener("mouseenter", () => {
        clearTimeout(hideTimeout);
        showTooltip();
      });
      el.addEventListener("mouseleave", () => {
        clearTimeout(showTimeout);
        hideTooltip();
      });
    } else if (event === "focus") {
      el.addEventListener("focus", showTooltip);
      el.addEventListener("blur", hideTooltip);
    } else if (event === "click") {
      el.addEventListener("click", showTooltip);
      docClickHandler = (e) => {
        if (!el.contains(e.target)) {
          hideTooltip();
        }
      };
      document.addEventListener("click", docClickHandler);
    }

    el._tooltipCleanup = () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
      if (docClickHandler) {
        document.removeEventListener("click", docClickHandler);
        docClickHandler = null;
      }
      tooltip.remove();
    };
  },
  unmounted(el) {
    el._tooltipCleanup?.();
    delete el._tooltipCleanup;
  },
};
export default tooltip;
